/**
 * The OS notification for a finished terminal command (Terminal board
 * card 5) — the calendarNotification.js shape: the notification plugin only,
 * lazily imported, Tauri only (listed in tauriImportsAreLazy.test.js). The
 * caller decides whether to notify (commandNotify.shouldNotify).
 */
import { isTauri } from './tauri';

let granted = null; // true | false | null (not asked yet)

async function plugin() {
  if (!isTauri()) return null;
  try {
    return await import('@tauri-apps/plugin-notification');
  } catch {
    return null;
  }
}

/** Show `{ title, body }`; a no-op outside the desktop app or without permission. */
export async function showTerminalNotification({ title, body }) {
  const mod = await plugin();
  if (!mod) return false;
  try {
    if (granted === null) {
      granted = (await mod.isPermissionGranted()) || (await mod.requestPermission()) === 'granted';
    }
    if (!granted) return false;
    mod.sendNotification({ title, body });
    return true;
  } catch {
    return false;
  }
}
